<template>
    <div class="col-sm-9 mx-auto">
        <div class="container mt-3">
            <h1>{{ message }}</h1>
        </div>

        <div class="row mt-2">
            <div class="col-sm-12"></div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import { ACTIONS, CORE_PREFIX } from '../store/constants';
  import { authService } from '../msal';
  export default {
      data() {
          return {
              message: 'Logging out...',
          };
      },
      mounted() {
          this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);

          localStorage.clear();
          this.deleteAllCookies();

          this.message = 'You are now logged out.';

          let self = this;
          window.setTimeout(function () {
              self.$AuthService.logout();
          }, 3000);
      },
      methods: {
          deleteAllCookies() {
              var cookies = document.cookie.split(';');

              for (var i = 0; i < cookies.length; i++) {
                  var cookie = cookies[i];
                  var eqPos = cookie.indexOf('=');
                  var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

                  //Dont clear language cookie on logout
                  if (name.trim() == 'language') {
                      continue;
                  }

                  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
              }
          },
      },
  };
</script>
